/**
 * Chiziqli ikonlar (24×24, stroke = currentColor) — navigatsiya va tuzilma elementlari uchun.
 * Kutubxonasiz: kerakli bir nechtasi inline.
 */
const PATHS = {
  home: 'M3 10.5 12 3l9 7.5V20a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1z',
  box: 'M12 2.8 20.5 7v10L12 21.2 3.5 17V7zM3.8 7.2 12 11.4l8.2-4.2M12 11.4v9.6M7.8 5l8.4 4.3',
  user: 'M12 12a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zM3.5 21a8.5 8.5 0 0 1 17 0',
  search: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM20.5 20.5 16 16',
  truck:
    'M2.5 6.5h11v10h-11zM13.5 10h4l3.5 3.5v3h-7.5M7 19.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM17 19.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4z',
  route:
    'M6 21a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM18 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM8.5 18.5H16a3.5 3.5 0 0 0 0-7H8a3.5 3.5 0 0 1 0-7h7.5',
  shield: 'M12 2.5 4 5.5v6c0 5 3.4 8.6 8 10 4.6-1.4 8-5 8-10v-6zM8.8 12l2.2 2.2 4.2-4.4',
  plus: 'M12 5v14M5 12h14',
  chevron: 'M9 5l7 7-7 7',
  arrowRight: 'M4 12h15M13 6l6 6-6 6',
  info: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 11v5.5M12 7.6v.2',
  inbox:
    'M3 13.5 5.8 5h12.4l2.8 8.5V19a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zM3 13.5h5l1.5 2.5h5l1.5-2.5h5',
  alert: 'M12 3.5 21.5 20h-19zM12 10v4.5M12 17.3v.2',
  camera:
    'M3 8a2 2 0 0 1 2-2h2.5L9 3.5h6L16.5 6H19a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM12 17a4 4 0 1 0 0-8 4 4 0 0 0 0 8z',
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({
  name,
  className = 'h-6 w-6',
  strokeWidth = 1.8,
}: {
  name: IconName;
  className?: string;
  strokeWidth?: number;
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
